import React from "react";

type props = {
    color?: string
    background?: string
}
export function Celular2({color="#01C292", background="#F0FFFA" }: props) {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" fill={background}/> //TODO: Change fill color
            <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke={color}/>
            <path d="M15.7188 3.125C16.582 3.125 17.3125 3.85547 17.3125 4.71875V18.5312C17.3125 19.4277 16.582 20.125
            15.7188 20.125H8.28125C7.38477 20.125 6.6875 19.4277 6.6875 18.5312V4.71875C6.6875 3.85547 7.38477 3.125
            8.28125 3.125H15.7188ZM12 19.0625C12.5645 19.0625 13.0625 18.5977 13.0625 18C13.0625 17.4355 12.5645 16.9375
            12 16.9375C11.4023 16.9375 10.9375 17.4355 10.9375 18C10.9375 18.5977 11.4023 19.0625 12 19.0625ZM15.7188
            15.4766V5.11719C15.7188 4.91797 15.5195 4.71875 15.3203 4.71875H8.67969C8.44727 4.71875 8.28125 4.91797
            8.28125 5.11719V15.4766C8.28125 15.709 8.44727 15.875 8.67969 15.875H15.3203C15.5195 15.875 15.7188 15.709
            15.7188 15.4766Z" fill={color}/>
            <path d="M9.81652 13V12.33C10.2565 11.9033 10.6532 11.51 11.0065 11.15C11.3665 10.79 11.6699 10.4567 11.9165
            10.15C12.1699 9.84333 12.3632 9.55667 12.4965 9.29C12.6299 9.02333 12.6965 8.77 12.6965 8.53C12.6965 8.19
            12.6065 7.92333 12.4265 7.73C12.2465 7.53 11.9865 7.43 11.6465 7.43C11.3999 7.43 11.1732 7.5 10.9665
            7.64C10.7665 7.78 10.5799 7.94667 10.4065 8.14L9.76652 7.5C10.0599 7.18667 10.3599 6.94667 10.6665
            6.78C10.9799 6.60667 11.3565 6.52 11.7965 6.52C12.1032 6.52 12.3799 6.56667 12.6265 6.66C12.8732 6.75333
            13.0832 6.88667 13.2565 7.06C13.4299 7.22667 13.5632 7.43 13.6565 7.67C13.7565 7.91 13.8065 8.17667 13.8065
            8.47C13.8065 8.75 13.7432 9.03667 13.6165 9.33C13.4965 9.61667 13.3299 9.91 13.1165 10.21C12.9099 10.5033
            12.6665 10.8067 12.3865 11.12C12.1065 11.4333 11.8099 11.7567 11.4965 12.09C11.6632 12.0767 11.8432 12.0633
            12.0365 12.05C12.2299 12.03 12.4032 12.02 12.5565 12.02H14.1165V13H9.81652Z" fill={color}/>
        </svg>
    )
}